import apiService from '../api/apiService';

export const ReturnOrderController = {
  // Approve a customer return for this merchant's product (ROLE_MERCHANT).
  // Triggers the refund.
  approveReturn: (returnItemQueueId: string) =>
    apiService.patch(`/orders/merchant/returns/${returnItemQueueId}/approve`),

  // Reject a customer return (ROLE_MERCHANT). Rolls back the return; no refund.
  rejectReturn: (returnItemQueueId: string, reason: string) =>
    apiService.patch(`/orders/merchant/returns/${returnItemQueueId}/reject`, { reason }),

  // Get returned items with pagination
  getMerchantReturnedItems: ({ page = 0, size = 10, ...otherParams } = {}) => {
    // Base URL with required pagination parameters
    const url = `/orders/merchant/returned-items?page=${page}&size=${size}`;

    // Add any additional filter parameters if needed
    const otherParamsEntries = Object.entries(otherParams).filter(([_, value]) => value !== undefined);
    const additionalParams = otherParamsEntries.map(([key, value]) => `&${key}=${encodeURIComponent(String(value))}`).join('');

    return apiService.get(url + additionalParams);
  },

  // Get this merchant's refunds (money refunded to customers for the merchant's
  // sub-order cancellations and returns) with pagination. Backed by the
  // ROLE_MERCHANT endpoint /orders/merchant/refunds.
  getMerchantRefunds: ({ page = 0, size = 10, ...otherParams } = {}) => {
    const url = `/orders/merchant/refunds?page=${page}&size=${size}`;
    const otherParamsEntries = Object.entries(otherParams).filter(([_, value]) => value !== undefined);
    const additionalParams = otherParamsEntries.map(([key, value]) => `&${key}=${encodeURIComponent(String(value))}`).join('');
    return apiService.get(url + additionalParams);
  },

  // Get returns data with pagination
  getReturns: ({ page = 0, size = 10, ...otherParams } = {}) => {
    // Base URL with required pagination parameters
    const url = `/orders/returns?page=${page}&size=${size}`;
    
    // Add any additional filter parameters if needed
    const otherParamsEntries = Object.entries(otherParams).filter(([_, value]) => value !== undefined);
    const additionalParams = otherParamsEntries.map(([key, value]) => `&${key}=${encodeURIComponent(String(value))}`).join('');
    
    return apiService.get(url + additionalParams);
  }
};